// Merkt PUT-Speicherungen vor, die an einem Netzwerkfehler (fetch wirft TypeError,
// d.h. kein Server erreichbar) gescheitert sind, und synchronisiert sie automatisch,
// sobald wieder eine Verbindung besteht. Persistiert in localStorage, damit ein
// zwischenzeitliches Neuladen/Schließen des Tabs die wartende Änderung nicht verliert.
//
// Pro Benutzer getrennt: Speichert ein Nutzer offline und loggt sich vor dem Sync
// ein anderer Nutzer auf demselben Gerät ein, darf dessen Session die fremde
// Änderung NICHT mitsenden (falsche Zuordnung in status_history bzw. 403, wenn der
// Lead nicht dem neuen Nutzer zugewiesen ist — und damit stiller Datenverlust).
const STORAGE_KEY = 'crm_offline_queue';

function readQueue() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function writeQueue(items) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  } catch {}
}

// Ein zweiter Offline-Save desselben Nutzers für denselben Lead ersetzt den
// vorherigen statt sich aufzustapeln — beim Sync zählt nur der letzte Stand.
export function enqueueOfflineSave(username, leadId, body) {
  const items = readQueue().filter(i => !(i.username === username && i.leadId === leadId));
  items.push({ username, leadId, body, queuedAt: new Date().toISOString() });
  writeQueue(items);
}

// Nur die wartenden Speicherungen des aktuell eingeloggten Nutzers — fremde Einträge
// bleiben unangetastet liegen, bis der jeweilige Nutzer sich wieder einloggt.
export function getOfflineQueueForUser(username) {
  return readQueue().filter(i => i.username === username);
}

export function removeFromOfflineQueue(username, leadId) {
  writeQueue(readQueue().filter(i => !(i.username === username && i.leadId === leadId)));
}
